import { showNotice } from "../helpers/functions.js";

$('html').on('click', '.user-controls .main-send-message-user-button', function (){
    const currentPath = window.location.pathname;
    const lastSubPath = currentPath.substring(currentPath.lastIndexOf('/') + 1);

    const currentUserId = lastSubPath.substring(lastSubPath.lastIndexOf("id") + 2);
    // ServerApi.users.getUserInfo(currentUserId).then((userInfo) => {

    // });

    const bannedErrorElement = $(".error-notification[banned]");

    if(bannedErrorElement.length !== 0)
        showNotice("Пользователь заблокирован. Вы не можете отправить ему сообщение", '', 'error');
    else
        window.location.replace(`/users/messages#messages${currentUserId}`);

});

